/**
 * Loading Spinner
 * Manages loading states
 */

export class LoadingSpinner {
  /**
   * Show initial loading spinner
   */
  static showInitial() {
    const spinner = document.getElementById('initial-loading-spinner');
    if (spinner) {
      spinner.style.display = 'flex';
    }
  }

  /**
   * Hide initial loading spinner
   */
  static hideInitial() {
    const spinner = document.getElementById('initial-loading-spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }
  }

  /**
   * Show submission loading spinner
   */
  static showSubmission() {
    const spinner = document.getElementById('submit-loading-spinner');
    if (spinner) {
      spinner.style.display = 'flex';
    }
  }

  /**
   * Hide submission loading spinner
   */
  static hideSubmission() {
    const spinner = document.getElementById('submit-loading-spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }
  }
}

